export default __webpack_public_path__ + "static/media/slider-6.c67e1c65.png";